import { useNavigate } from 'react-router-dom'

import ArrowIcon from 'assets/icons/arrow.svg'
import ArrowIconWhite from 'assets/icons/arrowwhite.svg'
import DownloadIcon from 'assets/icons/download.svg'
import { Button } from 'components/Button'
import { BVAphases } from 'constants/HomeConstants'

export const ProcessSection = () => {
  const navigate = useNavigate()
  const navigateTo = (url: string) => () => {
    navigate(url)
  }
  const handleDownload = () => {
    const link = document.createElement('a')
    link.href =
      'https://facade-api.dev.mos.coke.com/v3/download-file/bucket/facade-bucketstandarbackendstack-facade-development/bva%2F2026%2FBVAToolkit.pptx'
    link.download = 'sample.pdf'
    link.click()
  }
  return (
    <div id="bva-process-detail" className="flex justify-center process-bg-color mr-[-80px] ml-[-80px]">
      <div className="mx-auto text-center">
        <p className="title-xl pt-16">The BVA Process in detail</p>
        <p className="my-6 body-m max-w-[840px] mx-auto">
          Explore the five stages of building a meaningful Brand Vision Architecture. <br /> To update or redo your BVA,
          download the full toolkit or explore the step-by-step process below.
        </p>
        <div className="flex justify-center mb-10 font-bold">
          <Button
            text="Download Toolkit"
            color="white"
            className="px-[16px] py-[6px] mr-3"
            onClick={handleDownload}
            icon={<img src={DownloadIcon} alt="Download" className="ml-2" width="16" height="16" />}
          />
          <Button
            text="Explore BVA steps"
            color="black"
            className="px-[16px] py-[6px]"
            onClick={navigateTo('/process?Brand Assessment')}
            icon={<img src={ArrowIconWhite} alt="Arrow" className="ml-2" width="16" height="11" />}
          />
        </div>
        <div className="flex flex-wrap lg:flex-nowrap justify-center lg:justify-between gap-4 lg:gap-0 mb-10 lg:mb-16 text-left">
          {BVAphases.map((phase, index) => (
            <article
              onClick={navigateTo(`/process?${phase.title}`)}
              className="relative cursor-pointer overflow-hidden group bg-[#E0F5E3] p-4 h-[300px] w-[217px] rounded-2xl border-[2px]  mr-2 transition-all duration-400 hover:w-[318px] peer-hover:w-[192px] hover:bg-black hover:text-white last:mr-0 process-cards"
              key={index}
            >
              <section className="group-hover:opacity-0 group-hover:hidden">
                <h1 className="headline-xxl">{index + 1}</h1>
                <p className="subtitle-l pt-4 pb-2">{phase.title}</p>
                <p className="body-xs">{phase.subtitle}</p>
              </section>
              <section className="transform opacity-0 translate-y-10 transition-all group-hover:opacity-100 group-hover:translate-y-0 transition-transform duration-300 ease-in-out">
                {phase.hover}
              </section>
              <span className="absolute flex bottom-5 right-5">
                <p className="font-bold text-[14px] translate-x-[200px] group-hover:translate-x-0 transition-transform ease-in-out duration-300">
                  Explore phase
                </p>
                <img
                  src={ArrowIcon}
                  alt="Arrow"
                  className="absolute right-0 group-hover:hidden"
                  width="20"
                  height="13"
                />
                <img
                  src={ArrowIconWhite}
                  alt="Arrow"
                  className="translate-x-[200px] group-hover:translate-x-0 transition-transform ease-in-out duration-300 ml-2"
                  width="20"
                  height="13"
                />
              </span>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
